import React from 'react'
import {AdminLayout} from '../../../layout/AdminLayout'
import {HeaderPage} from '../../../components/HeaderPage'
import { HistoricMail } from '../../../components/Email/HistoricMail'
import { Button } from '../../../Korbantech/components/Buttons/Button'
import { useNavigate } from 'react-router-dom'

export const Email = () => {

    const navigate = useNavigate()

    return (
        <AdminLayout>
            <HeaderPage name='E-mail' button={<Button value="Novo Email" onClick={()=>navigate('/admin/emails/novo-email')}/>} />
            <HistoricMail />
        </AdminLayout>
    )
}